import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import DeliveryDetailsFleetModal from '../../../../components/management/fleets/auxModals/DeliveryDetailsFleetModal'
import { closeDeliveryDetailsFleetModal, fetchDeliveryDetailsFleetSuccess, fetchDeliveryDetailsFleet } from '../../../../actions/management/auxModals/auxModals'
import { openModal } from '../../../../actions/common'
import TrackingContainer from '../../../tracking/trackingContainer'
import { setOperateActionPrintDeliveryNoteProcess } from '../../../../actions/unattendedProcess/unattendedProcess'

export function mapStateToProps (state) {
  return {
    ...state.managementAuxModals.deliveryDetailsFleetModal
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      closeDeliveryDetailsFleetModal,
      fetchDeliveryDetailsFleetSuccess,
      fetchDeliveryDetailsFleet,
      openModal,
      setOperateActionPrintDeliveryNoteProcess
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(DeliveryDetailsFleetModal, true)))
